import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from './pages/Home';
import Project from './pages/Project';
import Contact from './pages/Contact';

function App() {
  return (
   <div>
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Project />} />
          <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
   </div>
  );
}

export default App;
